/**
 * Wire-encoding for a single RenderListDataAsStream FilterValue / FilterValues
 * querystring value.
 *
 * Byte-compatible with the legacy convention (raw value + clause-level "&"→"%26")
 * for every value that worked before: spaces and non-ASCII were already
 * percent-encoded by the browser's URL handling, and "&" encodes to the same
 * "%26". Only values containing "#", "%", "+" or ";" produce different bytes —
 * exactly the ones the legacy convention broke ("#" truncated the URL at the
 * fragment, "%" formed invalid escape sequences, "+" could decode as a space).
 *
 * `escapeSemicolons` applies SharePoint's ";;" literal-semicolon escape and must
 * be set when (and only when) the value is joined into a multi-value In-list
 * ("%3B%23"-separated) — mirroring the legacy selectedCount > 1 behaviour.
 *
 * DocIcon office-bucket items must NOT go through this function: their `value`
 * is a PRE-ENCODED extension list (see officeExtentions.*.values). Callers key
 * that exemption on `item.fileType`, which is set exclusively on DocIcon items.
 *
 * The taskpane grid query builder (getSharepointFiles) and the pre-select
 * existence probe (probeFilterValueExists) MUST both encode through this
 * function: if they ever encode a value differently, a strike decision can
 * contradict what the grid actually shows.
 *
 * KNOWN GAP: the content manager's grid (api-sharepoint-slice
 * renderListAsStream and friends) still emits filter values RAW — a
 * pre-existing defect for values containing "#", "%", "+" or ";", affecting
 * manual CM filters and pre-select alike. It is deliberately not changed as
 * part of the pre-select work because encoding there alters the wire bytes of
 * every manual CM filter; if it is ever fixed, port getSharepointFiles'
 * encoding block verbatim so the two builders stay in lockstep.
 */
export const encodeFilterValue = (value: string, escapeSemicolons = false): string => {
  const raw = value ?? "";
  return encodeURIComponent(escapeSemicolons ? raw.replaceAll(";", ";;") : raw);
};
